import * as React from 'react';

function LocationIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 28 42" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M14 0C6.316 0 0 5.992 0 14.538c0 3.05.72 5.172 2.053 7.522l11.005 19.384a1.077 1.077 0 001.884 0L25.947 22.06C27.281 19.71 28 17.588 28 14.538 28 5.992 21.684 0 14 0zm0 2.154c6.59 0 11.846 4.873 11.846 12.384 0 2.739-.532 4.287-1.767 6.462l-10.08 17.735L3.92 21c-1.234-2.175-1.766-3.723-1.766-6.462 0-7.51 5.256-12.384 11.845-12.384zm0 4.307C9.85 6.461 6.46 9.85 6.46 14S9.85 21.538 14 21.538 21.538 18.15 21.538 14 18.15 6.46 14 6.46zm0 2.154A5.368 5.368 0 0119.384 14 5.368 5.368 0 0114 19.384 5.368 5.368 0 018.615 14 5.368 5.368 0 0114 8.615z"
        fill="currentColor"
      />
    </svg>
  );
}

export default LocationIcon;
